import classNames from 'classnames';
import { ModalAnchorTrigger } from 'components/shared/ModalAnchorTrigger/ModalAnchorTrigger';
import { WorkflowErrorDetailsModal } from 'components/shared/WorkflowError/WorkflowErrorDetailsModal';
import { useSgBsTheme } from 'hooks/useSgBsTheme';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import { FC } from 'react';

import { StatusMessage } from './StatusMessage';
import { StatusPanel } from './StatusPanel';

type RejectionsProps = Readonly<{
  errorMessages: NextWorkflowError[];
  shouldDisplayErrorDetails: boolean;
  id: string;
}>;

export const Rejections: FC<RejectionsProps> = ({ id, errorMessages, shouldDisplayErrorDetails }) => {
  const theme = useSgBsTheme();

  const buttonId = `button-${id}`;
  return (
    <StatusPanel className="alert-danger" e2e="tile-rejections">
      <StatusMessage msgKey="dashboard.rejected" icon="do_disturb" />
      <ModalAnchorTrigger
        id={buttonId}
        e2e="tile-rejections-details-btn"
        text="dashboard.rejected.details"
        className={classNames('text-link fw-semibold', {
          'text-white': theme === 'light',
          'text-black': theme === 'dark',
        })}
      >
        {({ isOn, toggle }) => (
          <WorkflowErrorDetailsModal
            isOpen={isOn}
            toggle={toggle}
            errors={errorMessages}
            shouldDisplayErrorDetails={shouldDisplayErrorDetails}
          />
        )}
      </ModalAnchorTrigger>
    </StatusPanel>
  );
};

Rejections.displayName = 'Rejections';
